import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App as CapApp } from '@capacitor/app';

const log = (...a: any[]) => console.log('[SafeAreaGuard]', ...a);

function applyStatusBarStyle() {
  const isDark =
    document.documentElement.classList.contains('dark') ||
    window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  return StatusBar.setStyle({ style: isDark ? Style.Light : Style.Dark }).catch(() => {});
}

function measureInset(side: 'top' | 'bottom'): number {
  const probe = document.createElement('div');
  probe.style.cssText =
    side === 'top'
      ? 'position:fixed;top:0;height:env(safe-area-inset-top,0px);left:0;right:0;pointer-events:none;'
      : 'position:fixed;bottom:0;height:env(safe-area-inset-bottom,0px);left:0;right:0;pointer-events:none;';
  document.body.appendChild(probe);
  const h = Math.round(probe.getBoundingClientRect().height);
  probe.remove();
  return Math.max(0, h);
}

const sleep = (ms: number) => new Promise(res => setTimeout(res, ms));

export default function SafeAreaGuard() {
  useEffect(() => {
    // One-time iOS detection only - no more variable juggling
    const isIOS = Capacitor.getPlatform() === 'ios';
    if (isIOS) {
      document.documentElement.setAttribute('data-platform', 'ios');
    }
  }, []);

  return null;
}
